import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { cn } from '@bem-react/classname'

import { Button } from '@/components/UI/Button'

import './NotFound.scss'

const cnNotFound = cn('NotFound')

export const NotFound: FC = (): JSX.Element => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className={cnNotFound()}>
      <div className={cnNotFound('center')}>
        <div className={cnNotFound('number')}>404</div>
        <div className={cnNotFound('text')}>{t('notfound-page-not-found')}</div>
        <div className={cnNotFound('button')}>
          <Button onClick={() => navigate('/')}>
            {t('notfound-go-to-home')}
          </Button>
        </div>
      </div>
    </div>
  )
}
